import React, { useEffect } from "react";
import { NewPackageViewModel } from "../../viewmodels/packaging/NewPackageViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import SlideOver from "../../components/slideOver/SlideOver";

import NewPackageForm from "../../components/forms/packaging/NewPackageForm";
import EmptyModal from "../../components/modals/EmptyModal";
import {
  USER_DEPARTMENT_CODE,
  USER_TYPE_CODE,
} from "../../shared/userReferenceCodes";

function NewPackageScreen(props: any) {
  const { addSnackbar, logout } = props;
  const {
    getManufacturedItemById,
    emptyModal,
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
    employeeOptions,
    getUsersForDropdown,
    getInContactPackagingSupplies,
    savePackagingDetailsAndPrint,
    getBrands,
    brands,
    showErrorModal,
    printingLabelType,
    scaleIsOpen,
    setScaleIsOpen,
    printedPackageItems,
    deleteSinglePackagedItem,
    reprintPackageLabel,
    packagingLabel,
    setPackagingLabel,
    fetchProductByPlu,
    printProgress,
    deleteInProgress,
    supervisorOptions,
    lotNumbers,
    onSearchLotNumbers,
  } = NewPackageViewModel(logout);

  useEffect(() => {
    getUsersForDropdown(USER_TYPE_CODE.SUPERVISOR, [
      USER_DEPARTMENT_CODE.ALL,
      USER_DEPARTMENT_CODE.PACKAGING,
    ]);
    getUsersForDropdown(USER_TYPE_CODE.REGULAR, [
      USER_DEPARTMENT_CODE.ALL,
      USER_DEPARTMENT_CODE.PACKAGING,
    ]);
    getBrands("");
  }, []);

  function printPackagingLabel(labelDetails: any) {
    setTimeout(function () {
      window.print();

      if (labelDetails.printCounter < labelDetails.serials.length) {
        const newLabelDetails = {
          ...labelDetails,
          printCounter: labelDetails.printCounter + 1,
        };

        setPackagingLabel(newLabelDetails.serials[labelDetails.printCounter]);

        printPackagingLabel(newLabelDetails);
      }
    }, 1500);
  }

  return (
    <div className="qatrace-screen qatrace-module-page">
      <div className="hide-for-print mt-2">
        <NewPackageForm
          lotNumbers={lotNumbers}
          employeeOptions={employeeOptions}
          isEdit={false}
          getManufacturedItemById={getManufacturedItemById}
          packagedProduct={null}
          setEmptyModelOpen={setEmptyModelOpen}
          setSlideOver={setSlideOver}
          savePackagingDetailsAndPrint={savePackagingDetailsAndPrint}
          packagingLabel={packagingLabel}
          getInContactPackagingSupplies={getInContactPackagingSupplies}
          setPackagingLabel={setPackagingLabel}
          brands={brands}
          showErrorModal={showErrorModal}
          setScaleIsOpen={setScaleIsOpen}
          scaleIsOpen={scaleIsOpen}
          printedPackageItems={printedPackageItems}
          onSearchLotNumbers={onSearchLotNumbers}
          deleteSinglePackagedItem={deleteSinglePackagedItem}
          reprintPackageLabel={reprintPackageLabel}
          fetchProductByPlu={fetchProductByPlu}
          printProgress={printProgress}
          deleteInProgress={deleteInProgress}
          supervisorOptions={supervisorOptions}
        />
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        customClass={slideOver.size ? slideOver.size : "max-w-7xl"}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (_state: unknown) => {
  return {};
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar: any) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NewPackageScreen),
);
